// extracted by mini-css-extract-plugin
export default {"body":"log_body__MWfO3","trans":"log_trans__XKRMm","st":"log_st__IQOQL","st_image":"log_st_image__9RThz","btnlog":"log_btnlog__bZhwr"};